<template>
  <div class="dropdown standalone-menu" v-on-click-outside="selectedHandler">
    <button
      class="btn dropdown-toggle"
      v-safe-class="buttonClasses"
      type="button"
      data-toggle="dropdown"
      aria-haspopup="true"
      :disabled="props.disabled"
      :aria-expanded="viewModel.open"
      @click.prevent="viewModel.open = !viewModel.open">
      <Icon v-if="icon" :core-ui="resolvedIcon.isCoreUI" :icon="resolvedIcon.kind"></Icon> {{ props.text || "" }}
    </button>
    <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton" :class="{ show: viewModel.open, right: props.right }">
      <dropdown-child-menu v-for="(entry, index) in items" :item="entry" :key="index" @selected="selectedHandler"></dropdown-child-menu>
    </ul>
  </div>
</template>
<script lang="ts" setup>
import { DropdownMenuItem } from "@medapro-types/common/components/DropdownMenu";
import DropdownChildMenu from "./DropdownChildMenuItem.vue";
import { computed, reactive } from "vue";
import Icon from "../Icon.vue";

const props = defineProps<{
  text: string;
  icon?: string;
  buttonClass?: string;
  items: DropdownMenuItem[];
  right: boolean;
  disabled?: boolean;
}>();

const items = computed(() => props.items || []);

const resolvedIcon = reactive({
  isCoreUI: !props.icon?.startsWith("mdp"),
  kind: props.icon?.replace(/^(.){4}/, "").trim()
});

const buttonClasses = computed(() => props.buttonClass || "mono");

const viewModel = reactive({
  open: false
});

function selectedHandler() {
  viewModel.open = false;
}

defineExpose({ selectedHandler });
</script>
<style></style>
